import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStopwatchIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 11.073,
	height: 12.919,
	viewBox: "0 0 11.073 12.919",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Icon_ionic-md-stopwatch",
		"data-name": "Icon ionic-md-stopwatch",
		transform: "translate(-4.5 -2.25)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Path_3126",
			"data-name": "Path 3126",
			d: "M16.313,16.143H17.7V12.375H16.313Z",
			transform: "translate(-6.968 -5.973)",
			fill: "#8d8b9c"
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_2648",
			"data-name": "Group 2648",
			transform: "translate(4.5 2.25)",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Path_3127",
				"data-name": "Path 3127",
				d: "M14.41,8.892,15.3,8l-.979-.979-.888.888a5.537,5.537,0,1,0,.979.979ZM13.1,15.345a4.325,4.325,0,1,1,1.267-3.059A4.3,4.3,0,0,1,13.1,15.345Z",
				transform: "translate(-4.5 -4.904)",
				fill: "#8d8b9c"
			}), /* @__PURE__ */ _jsx("path", {
				id: "Path_3128",
				"data-name": "Path 3128",
				d: "M13.5,2.25h3.691V3.634H13.5Z",
				transform: "translate(-9.809 -2.25)",
				fill: "#8d8b9c"
			})]
		})]
	})
});
export default SvgStopwatchIcon;
